import { LoadingSpinner, Grid } from '@simplywallst/ui-core';

export const LoadingState = () => (
  <Grid placeContent="center">
    <LoadingSpinner light />
  </Grid>
);
